import Resource from "../base/resource";
import MenuHelper from './menuHelper';
import meshRestrictionHelper from '../../meshRestriction/meshRestrictionHelper';

class Menu extends Resource {
    constructor(props) {
        super(props);
        this._previousMenuItemData = [];
    }

    async load(onLoadCallback) {
        if (wv.effectController.stoppedTrainingId === TrainingTreeController._trainingFeature.getActiveTraining()?.id) {
            return;
        }

        onLoadCallback(1);
    }

    setState(state) {
        if (state.menuItems && state.menuItems.length === 0) {
            MenuHelper.removeRestriction(state.restrictions);
            return MenuHelper.updateMenuItem(this._previousMenuItemData);
        }

        this._previousMenuItemData = MenuHelper.saveMenuItem(state.menuItems);
        MenuHelper.updateMenuItem(state.menuItems);
        MenuHelper.enableRestriction(state.restrictions);
    }

    mergeStates(initialState) {
        if (this.states.length === 0) {
            return initialState;
        }

        let finalState = initialState;
        this.states.forEach(state => {
            const menuItems = state.menuItems;

            menuItems.forEach(menuItem => {
                let availableMenuItem = getMenuItem(menuItem.name);
                if (availableMenuItem) {
                    availableMenuItem.value = menuItem.value;
                } else {
                    if (!finalState.menuItems) {
                        finalState.menuItems = [];
                    }

                    finalState.menuItems.push({...menuItem});
                }
            });

            if (state.hasOwnProperty('restrictions')) {
                finalState.restrictions.push(...state.restrictions);
            }
        });

        this.states = [];
        return finalState;

        function getMenuItem(menuName) {
            return finalState.menuItems?.find(menuItem => menuItem.name === menuName);
        }
    }

    getDefaultState() {
        return {
            menuItems: [],
            restrictions: []
        };
    }

}

export default Menu;
